import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import NotFoundContainerQuery, {
	type NotFoundContainerQuery$data,
	type NotFoundContainerQuery$variables,
} from './__generated__/NotFoundContainerQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export const preloadDraftRedirect = ({
	contentId,
	draftShareId,
}: {
	contentId: string;
	draftShareId: string;
}): Promise<{
	data: NotFoundContainerQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> => {
	return query<NotFoundContainerQuery$data, NotFoundContainerQuery$variables>({
		query: NotFoundContainerQuery,
		variables: { contentId, draftShareId, status: ['draft'] },
	});
};
